import React, { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';

import { consentManager } from '@wetransfer/transfer/modules/consent-manager';
import {
  accept,
  isCcpaAccepted,
  getCcpaCookieState,
} from '@wetransfer/transfer/modules/consent-manager/ccpa-manager';
import {
  showCcpaBanner,
  closeCcpaBanner,
} from '@wetransfer/transfer/modules/consent-manager/tracker';
import Privacy from '@wetransfer/transfer/modules/privacy';

import Banner from './banner';

import './banner.scss';

export default function CCpaBanner(): JSX.Element {
  const [open, setOpen] = useState(false);
  const [isCcpaShown, setCcpaShown] = useState(false);
  const ccpaCookieState = getCcpaCookieState();

  useEffect(() => {
    showCcpaBanner();
    setOpen(isCcpaShown);
  }, [isCcpaShown]);

  useEffect(() => {
    // on first load ccpaCookieState = null
    if (ccpaCookieState === null) {
      // set cookie with accept state
      // show ads
      consentManager.acceptAll();
      Privacy.acceptTrackers();
      setCcpaShown(true);
      accept();
    }

    if (isCcpaAccepted(ccpaCookieState) === false) {
      consentManager.rejectAll();
      Privacy.declineTrackers();
    }
  }, [ccpaCookieState]);

  const closeBanner = () => {
    closeCcpaBanner();
    setOpen(false);
  };

  return (
    <CSSTransition
      in={open}
      timeout={400}
      mountOnEnter
      unmountOnExit
      classNames={'banner__animations'}
    >
      <Banner closeBanner={closeBanner} />
    </CSSTransition>
  );
}
